module.exports = __webpack_public_path__ + "static/img/son5_active.f6e8db04.png";